import React, { useRef } from "react";
import PropTypes from 'prop-types';
import { perPage } from '../../config';
import Paginator from '../components/Paginator.jsx';
import { ThreeDots } from '../components/common/Placeholders.jsx';

export const ClientSidePaginationListEasy = (Component) => {
  class ClientPaginationList extends React.Component {
    static propTypes = {
      list: PropTypes.array.isRequired,
    };
    
    constructor(props) {
        super(props);
        this.state = {
          isLoading: true,
          page: 0,
          count: 0,
          offset: 0,
          paginateList: []
        };
        this.ref = React.createRef();
        this.onPage = this.props.pageSize || perPage;
    }
    
    componentDidMount() {
      this.props.loadListFromServer().then(() => { this.setState({isLoading: false}) });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevState.page !== this.state.page){
          this.setState({
            paginateList: this.getPaginateList()
          })
      }
      if (prevProps.list !== this.props.list){
          this.setState({
            page: 0,
            offset: 0,
            count: this.props.list.length,
            paginateList: this.getPaginateList()
          })
      }
    }

    getPaginateList(){
      return this.props.list.slice(this.state.offset, this.state.offset + this.onPage);
    }

    handlePageClick = data => {
      this.setState({
        page: data.selected,
        offset: (data.selected * this.onPage)
      });
      this.ref.current.scrollIntoView({ top: '-10px', behavior: 'smooth'});
    };

    render() {
      if (this.state.isLoading) {
        return <ThreeDots/>;
      }
      return <div ref={this.ref}>
        <Component {...this.props} { ...this.state }/>
        <Paginator forcePage={this.state.page}
                   count={this.state.count}
                   pageSize={ this.props.pageSize }
                   onPageChange={this.handlePageClick}/>
      </div>
    }
  }
  return ClientPaginationList;
}
